import React from 'react';
import { ENTER, TEXTAREA } from '../constants/constant';

interface EnterKeyHandlerOptions {
  isEnabled: boolean;
  onEnter: () => void;
  blockWhileLoading?: boolean;
  isLoading?: boolean;
  allowInTextarea?: boolean;
}

export const createEnterKeyHandler =
  ({
    isEnabled,
    onEnter,
    blockWhileLoading = true,
    isLoading = false,
    allowInTextarea = false,
  }: EnterKeyHandlerOptions) =>
  (e: React.KeyboardEvent) => {
    if (e.key !== ENTER) return;

    if (!allowInTextarea && e.target instanceof HTMLElement) {
      const textareaOverride = e.target.dataset?.assetronAllowEnter === 'true';
      if (e.target.tagName === TEXTAREA && !textareaOverride) return;
    }

    if (!isEnabled) return;
    if (blockWhileLoading && isLoading) return;

    e.preventDefault();
    onEnter();
  };
